/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import classNames from 'classnames';
import styled from 'styled-components';

import { colors } from '../../../../theme';

interface ITableHeaderStyled {
    isSortActive: boolean;
    isSortable: boolean;
}

export const TableHeaderStyled = styled.div.attrs(({ isSortActive, isSortable }: ITableHeaderStyled) => ({
    className: classNames('header-cell', {
        'header-cell_sortable': isSortable,
        'header-cell_active': isSortActive,
    }),
}))<ITableHeaderStyled>`
    width: 100%;

    &.header-cell_active:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;

        display: block;
        width: 100%;
        height: 2px;

        background: ${colors.backgroundColorHoverGreen};
    }

    &.header-cell_sortable {
        .header-cell__label {
            cursor: pointer;

            &:hover {
                color: ${colors.textColor};
            }
        }
    }

    .header-cell__label {
        display: flex;
        justify-content: space-between;
        color: ${colors.textColorOpacity};

        &:not(:last-child) {
            margin-bottom: 4px;
        }
    }
`;
